import { createFileRoute } from '@tanstack/react-router'
import { galleryDetailSearchSchema } from '../../../../search-schemas'
import { useMediaData } from '../../../../../../../../../containers/Media/use-media-data'
import GalleryMediaWrapper from '../../../../../../../../../containers/Gallery/components/gallery-media-wrapper'

const GALLERY_ROUTE_ID =
  '/_authenticated/project/$projectId/media/gallery/$year/$month/$fileId/'

export const Route = createFileRoute(GALLERY_ROUTE_ID)({
  validateSearch: galleryDetailSearchSchema,
  component: GalleryRoute
})

function GalleryRoute() {
  const { year, month, fileId } = Route.useParams()
  const { mediaData } = useMediaData()

  return (
    <GalleryMediaWrapper
      mediaObject={mediaData}
      year={year}
      month={month}
      fileId={fileId}
    />
  )
}
